export const VoidablePayments = ['invoice', 'datman credit', 'setup fee'];

export const VoidedPayments = {
    VOIDED_TRANSACTION: 'returned',
    INCORRECT_TRANSACTION: 'mistakenly charged'
};

export const VoidedPaymentsArray = Object.values(VoidedPayments);
